import { api } from "@/api";
import {
  UpsertLeagueSuspensionsParams,
  LeagueSuspensionsEditorResponse,
} from "@/types/ApiResponses/League";

export const upsertLeaguesSuspensions = async (
  data: UpsertLeagueSuspensionsParams
): Promise<LeagueSuspensionsEditorResponse> => {
  const res = await api.client.post(`/leagues-new/suspensions`, data);
  return res.data;
};
